<template>
	<tr class="step-analytics-row" :class="{deleted: step.is_deleted, 'clickable':clickable, open:open}" :data-id="step.step_id">
		<td class="step-name-td" @click="$emit('click')">
			<div class="step-name">
				<inline-svg v-if="clickable" class="arrow" :src="require('@/assets/img/arrow-bottom.svg')" />
				<strong v-if="step.is_deleted" class="name">{{ step.name }}</strong>

<!--				<router-link v-else :to="'/wfunnel/'+$route.params.id+'/steps/'+step.step_id">-->
					<strong class="name">{{ step.name }}</strong>
<!--				</router-link>-->
			</div>
		</td>

		<td v-if="step.unique_next_steps || step.optins || step.orders" class="conv-rate-td">
			<tippy theme="small-black">
				<template v-slot:trigger>
					<div>
						<span class="bar"
					      :style="`width:${Math.max(1, Math.min(percentage(step.orders+step.unique_next_steps, step.unique_visits), 100))}%`" />
						<value-diff :value="percentage(step.orders+step.unique_next_steps, step.unique_visits)"
						            no-old-value suffix="%" :digits="2" />
					</div>
				</template>
				<div>
					<table class="__brief-tooltip">
						<tr v-if="step.unique_next_steps">
							<td>{{step.unique_next_steps}}</td>
							<td>Unique click-through</td>
						</tr>
						<tr v-if="step.orders">
							<td>{{step.orders}}</td>
							<td>Orders</td>
						</tr>
						<tr v-if="step.optins">
							<td><value-diff :value="percentage(step.optins, step.unique_visits)"
							                no-old-value suffix="%" :digits="2" /></td>
							<td>Optin rate</td>
						</tr>
						<tr v-if="step.optins">
							<td>{{step.optins}}</td>
							<td>Optins</td>
						</tr>
					</table>
				</div>
			</tippy>
		</td>
		<td v-else class="conv-rate-td">
			<span class="bar"
			      :style="`width:${Math.max(1, Math.min(percentage(step.orders, step.unique_visits), 100))}%`" />
			<value-diff :value="percentage(step.orders, step.unique_visits)"
			            no-old-value suffix="%" :digits="2" />
		</td>

		<td >
			<value-diff :value="step.revenue" no-old-value :prefix="currencyCode" is-money />
		</td>
		<td >
			<value-diff :value="step.orders" no-old-value suffix="" />
		</td>
		<td >
			<value-diff :value="step.unique_visits" no-old-value suffix="" />
		</td>
		<td >
			<value-diff :value="step.pageviews" no-old-value suffix="" />
		</td>
		<td class="_downstream-revenue">
			<v-spinner class="__spinner" v-if="loading" dots dots-color="#555" />
			<value-diff v-else :value="downstream_revenue" no-old-value :prefix="currencyCode" is-money />
		</td>
		<td class="_downstream-orders">
			<v-spinner class="__spinner" v-if="loading" dots dots-color="#555" />
			<value-diff v-else :value="downstream_orders" no-old-value suffix="" />
		</td>
	</tr>

</template>

<script>
import ValueDiff from "@/views/funnels/funnel/valueDiff";
import {percentage} from "@/helpers/analytics";
import {mapGetters} from "vuex";
import {getSymbol} from "@/helpers/currencies";
import API from "@/api";
import VSpinner from "@/components/base/v-spinner";

export default {
	name: "StepAnalyticsRowV2", components: {VSpinner, ValueDiff},
	props: ["step",'open', "loadingSteps", 'startDate', 'endDate','oldStartDate', 'oldEndDate', 'getConditions'],
	mixins: [API],
	data() {
		return {
			loading:false,
			downstream_revenue:false,
			downstream_orders:false,
		}
	},
	computed:{
		...mapGetters(["getFunnelStore",]),
		clickable(){
			if (!this.step.pages || !this.step.pages.length) return false;
			// for (let i=0; i < this.step.pages.length; i++){
			// 	let p = this.step.pages[i]
			// 	if (p.products && p.products.length > 0)
			// 		return true
			// }
			return true;
		},
		currencyCode() {
			let currency = this.getFunnelStore.currency_code;
			return getSymbol(currency);
		},
	},
	watch: {
		loadingSteps:{
			handler(val, oldVal){
				if (val && !oldVal) {
					this.loadSummary()
				}
			}
		}
	},
	methods:{
		percentage(sub,total) {
			return percentage(sub,total)
		},
		async loadSummary() {
			try {
				this.loading = true;
				let id = this.$route.params.id;
				let data = await this.api.analytics.getDownstreamSummary(id, this.step.step_id, 0,
						this.startDate, this.endDate, this.oldStartDate, this.oldEndDate, this.getConditions());

				this.downstream_revenue = data.revenue;
				this.downstream_orders = data.orders;

				// this.values[chart] = data
			} catch (e) {
				console.error(e)
			} finally {
				this.loading = false;
			}
		},
	},
	mounted() {
		this.loadSummary()
	}
}
</script>

<style lang="scss" scoped>
.__brief-tooltip {
	padding: 0 4px;
	tr {
		font-weight: 500;
	}
	tr td:first-child {
		font-weight: bold;
		padding-right: 10px;
	}
}
.step-analytics-row {
	td._downstream-revenue, td._downstream-orders {
		position: relative;
		text-align: right;
		align-content: end;
		.__spinner {
			right: 0;
			left: auto;
		}
	}
	&.open {
			td {
				border-top: 1px solid #e6eff7;
				border-bottom: 1px solid #e6eff7;
			}
	}
	&:hover {
		td {
			background: #f5f6f8 !important;
		}
	}
	//&.clickable {

		.step-name {
			cursor: pointer;
			.name {
				white-space: nowrap;
				max-width: 300px;
				overflow: hidden;
				text-overflow: ellipsis;
				display: block;
			}
			.arrow {
				margin-right: 5px;
			}
			.arrow {
				position: absolute;
				left: -20px;
			}
		}
		&.open{
			.arrow {
				transform: rotate(180deg);
			}
		}
		.step-name-td:hover {
			cursor: pointer;
			.name {
				color: $sharp-blue;
			}
		}
	//}
	td:first-child {
		padding-left: 30px;
		width: 100%;
	}
	&.deleted {
		.step-name {
			.name {
				pointer-events: none;
			}
		}
	}
}
</style>
